import { createSlice } from '../../../canvas/core';
import * as updaters from './state-updaters';
import type { TranslationLayerDeps, TranslationLayerSlice } from './types';

export const createTranslationLayerSlice =
  createSlice<TranslationLayerDeps>()<TranslationLayerSlice>(
    (set, _get, _api) => ({
      translationLayer: {
        state: {
          activeRectId: null,
          activePageId: null,
        },

        actions: {
          setActiveRect: (pageId, rectId) => {
            set(updaters.setActiveRect(pageId, rectId));
          },

          clearActiveRect: () => {
            set(updaters.clearActiveRect());
          },
        },
      },
    })
  );
